export const authenticated = state => state.authenticated
export const profile = state => state.profile

export const tokenExpired = state => {
  return state.expiresAt < Date.now()
}
